<ui-card [class.loading]="isLoading">
    <app-segment-header
        title="payroll.taxForms.{{ returnType() }}.employee.details"
        [allowEdit]="taxForm().isOpen"
        (edit)="onEditBoxes.emit()"
    ></app-segment-header>

    @if (hasErrors()) {
        <ui-banner variant="danger">{{
            'payroll.taxForms.atLeastOneBoxContainsAnErrorOrIsMissingARequiredValueUpdateTheIn' | translate
        }}</ui-banner>
    }
    <div class="flex col">
        @for (groupedBoxes of boxes(); track $index) {
            @if (groupedBoxes.title) {
                <h3>
                    {{ groupedBoxes.title | translate }}
                </h3>
            }
            <app-employee-tax-form-box class="padding-x-2" [taxForm]="taxForm()" [boxes]="groupedBoxes.boxes" />
        }
    </div>
</ui-card>
